import React from "react";
import {
  useLocation,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

const withRouterV6 = (WrappedComponent) => (props) => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const goBack = (page = -1) => {
      navigate(page);
    };

    return (
      <WrappedComponent
        {...props}
        match={{ params }}
        history={{ push: navigate, location, goBack }}
        location={location}
        searchParams={searchParams}
      />
    );
  };

export default withRouterV6;
